import React, { Component } from "react";
import {
  Modal,
  Statistic,
  Image,
  Table,
  Label,
  Button,
  Icon,
  Input,
} from "semantic-ui-react";
import { NavLink } from "react-router-dom";

import { LADDER, waitingLabel } from "../../utils/clubWorkflow";

/**
 * Clubs on the dashboard, in the same five cards subjects and conducts use.
 *
 * A club's marks climb the same ladder, so they are counted the same way and
 * wear the same faces: To Do, Created, Checked, Reviewed, Approved. Anything
 * that has come back to its moderator - Discarded, Resubmit - counts as To Do,
 * because that is where it now sits and who now owns it.
 *
 * The cards show every club, the way the subject cards show every subject, so
 * a level head can see what is coming as well as what is theirs today. Which
 * ones are actually their move is marked inside.
 */
const CARDS = [
  {
    key: "To Do",
    label: "To Do",
    className: "to-do",
    labelClass: "to-do-label",
    icon: "dashboard/ToDo.png",
    holds: ["To Do", "Discarded", "Resubmit"],
  },
  {
    key: "Created",
    label: "Created",
    className: "created",
    labelClass: "created-label",
    icon: "dashboard/Created.png",
    holds: ["Created"],
  },
  {
    key: "Checked",
    label: "Checked",
    className: "checked-status",
    labelClass: "checked-label",
    icon: "dashboard/Checked.png",
    holds: ["Checked"],
  },
  {
    key: "Reviewed",
    label: "Reviewed",
    className: "reviewed",
    labelClass: "reviewed-label",
    icon: "dashboard/Review.png",
    holds: ["Reviewed"],
  },
  {
    key: "Approved",
    label: "Approved",
    className: "approved",
    labelClass: "approved-label",
    icon: "dashboard/Approved.png",
    holds: ["Approved"],
  },
];

class ClubStatusCard extends Component {
  state = { searchKey: "" };

  render() {
    const { card, clubs, quarter } = this.props;

    const searchKey = this.state.searchKey.toLowerCase();
    const shown = clubs.filter(
      (c) => !searchKey || String(c.name).toLowerCase().indexOf(searchKey) !== -1
    );

    const rows = shown.map((club) => {
      const rung = LADDER[club.status || "To Do"];

      return (
        <Table.Row key={club.clubId} className="sections-table-row">
          <Table.Cell>{club.name}</Table.Cell>
          <Table.Cell textAlign="center">{club.members}</Table.Cell>
          <Table.Cell textAlign="center">
            {/* The moderator is the one with typing left; an approver is not. */}
            {club.isModerator && club.unmarked > 0 ? (
              <strong>{`${club.unmarked} still to mark`}</strong>
            ) : club.members === 0 ? (
              <span>Nobody in it yet</span>
            ) : (
              <span>
                <Icon name="check" color="green" />
                All marked
              </span>
            )}
          </Table.Cell>
          <Table.Cell textAlign="center">
            {club.awaits ? <strong>Your move</strong> : waitingLabel(club.status)}
          </Table.Cell>
          <Table.Cell textAlign="center">
            <NavLink to="/clubs">
              <Button size="tiny" primary={club.awaits}>
                {club.awaits && rung ? rung.action : "Open"}
              </Button>
            </NavLink>
          </Table.Cell>
        </Table.Row>
      );
    });

    return (
      <Modal
        closeIcon
        trigger={
          <Statistic className={card.className}>
            <Statistic.Value>
              <span className="stat-value">{clubs.length}</span>
              <Image src={card.icon} inline />
            </Statistic.Value>
            <Statistic.Label className="stat-label">{card.label}</Statistic.Label>
          </Statistic>
        }
      >
        <Modal.Header>
          Clubs
          <Label className={card.labelClass} horizontal>
            {card.label.toUpperCase()}
          </Label>
        </Modal.Header>
        <Modal.Content>
          <Input
            fluid
            icon="search"
            value={this.state.searchKey}
            onChange={(e) => this.setState({ searchKey: e.target.value })}
            placeholder="Search Clubs"
          />
          {clubs.length > 0 ? (
            <Table celled striped size="small">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign="center">Club</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Members</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">
                    {`Term ${quarter}`}
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Waiting on</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Action</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>{rows}</Table.Body>
            </Table>
          ) : (
            <h3>Nothing here.</h3>
          )}
        </Modal.Content>
      </Modal>
    );
  }
}

class ClubsModal extends Component {
  render() {
    const { clubs, quarter } = this.props;

    if (!clubs || clubs.length === 0) return null;

    return (
      <React.Fragment>
        {CARDS.map((card) => (
          <ClubStatusCard
            key={card.key}
            card={card}
            quarter={quarter}
            clubs={clubs.filter(
              (c) => card.holds.indexOf(c.status || "To Do") !== -1
            )}
          />
        ))}
      </React.Fragment>
    );
  }
}

export default ClubsModal;
export { CARDS };
